import { render, staticRenderFns } from "./AdminClientContacts.vue?vue&type=template&id=73180d98"
import script from "./AdminClientContacts.vue?vue&type=script&lang=js"
export * from "./AdminClientContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports